import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Grid,
  Link,
  Divider
} from "@mui/material";

const Footer = () => {
  return (
    <Box component="footer" sx={{ backgroundColor: 'background.paper', py: 6, mt: 8, pb: {xs: 14, md: 4} }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="space-between">
          <Grid size={{ xs: 12, sm: 4 }}>
            <Typography variant="h6" gutterBottom>
              DocuVault
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Secure cloud storage tailored for South African users. Built with privacy and simplicity in mind.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, sm: 4 }}>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            <Box sx={{ fontSize: '0.875rem', color: 'text.secondary' }}>
              <Link component={RouterLink} to="/" color="inherit" underline="hover" display="block">Home</Link>
              <Link component={RouterLink} to="/pricing" color="inherit" underline="hover" display="block">Pricing</Link>
              <Link component={RouterLink} to="/contact-us" color="inherit" underline="hover" display="block">Contact</Link>
            </Box>
          </Grid>

          <Grid size={{ xs: 12, sm: 4 }}>
            <Typography variant="h6" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {/*Email: support@docuvault.co.za<br />
              Phone: +27 10 123 4567<br />*/}
              Pretoria, South Africa
            </Typography>
          </Grid>
        </Grid>
        <Divider sx={{ my: 4 }} />
        <Typography variant="body2" color="text.secondary" align="center">
          © {new Date().getFullYear()} DocuVault. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;